import { Component, OnInit,OnDestroy, NgZone, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { filter, tap } from 'rxjs';
import * as $ from 'jquery'
import { GalleryService } from '../../providers/gallery.service';
import { LoggerService } from '../../providers/logger.service';
import { UserService } from '../../providers/user.service';
import {
  wrappergDriveTokenClient, wrapperSetGDriveAccessToken, wrapperGetgDriveAccessToken, wrapperGetNativeLogin, wrapperRequestNativeLogin,
  wrapperGetSiteLanguage, wrapperGetSiteVersion, wrapperGetSiteLogo, wrapperGetLogoUrlInApp, wrapperupdateUserUI, wrapperRegisterWebhookCallback,
  wrapperRegisterCloseCallback, wrapperGetCalledFromClientApi
} from '../../javascript.js';
import { DialogService } from '../../dialogs/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {
  files = [];
  dragClass = "dropHere-inactive";
  loading = false;
  documents: any;
  mobileDevice = false;

  dbOptions = {
    success: null,
    cancel:  { },
    linkType: "direct",
    multiselect: false,
    extensions: ['.swrd', '.jpg', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.odt'],
  };

  gDriveDeveloperKey = 'AIzaSyBs-xUC59dkZrPvBOfpNaJOBxbCNmOfH7Q';

 //gDriveClientId = "20355500945-rb66qd3j5ju90l08rrq1pojuvvhjsk0t.apps.googleusercontent.com";
 //gDriveScope = ['https://www.googleapis.com/auth/drive', 'https://www.googleapis.com/auth/drive.file'];
 //gDriveToken: string = '';

// uploadTag = document.getElementById("fileInput");
//if (uploadTag) uploadTag.addEventListener('change', uploadFileFromFileInput, false);

  constructor(
    private router: Router,
    private dialogs: DialogService,
    private ngZone: NgZone,
    private gallery: GalleryService,
    private logger: LoggerService,
    private user: UserService,
    private location: Location,
    private translateService: TranslateService
  ) {
    // on every controller where we use dialogs - dismiss on destroy!
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      tap(event => {
        this.dialogs.dismissAllDialogs();
      })
    );
  }

  ngOnInit(): void {
    wrapperupdateUserUI();

    // FastSpring sometimes puts data in URL anchor part (e.g. when customer returns from PayPal).
    // In such scenarios the default route is loaded ('upload' in our case) and, since this is the
    // default route, we must process FastSpring's data and reroute 
    if (this.fastSpringUrlProcessed()) {
      return;
    }

    this.dbOptions = {
      success: data => { this.dropboxCallback(data) },
      cancel: {},
      linkType: "direct",
      multiselect: false,
      extensions: ['.swrd', '.jpg', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.odt'],
    };
    // register store callbacks
    this.registerCallbacks(true);
    // Set URL of logo:
    this.setLogoUrl();
    this.activate();

    //var translations = {};
    //$translate(['Error', 'document', 'CouldNotDeleteTheFile', 'CouldNotOpenFile', 'CouldNotOpenFileTooBig', 'UnsupportedFileFormat', 'SelectDocument']).then(
    //  (tr) { translations = tr }
    //);
  }

  ngOnDestroy(): void {
    this.registerCallbacks(false);
    this.setOverflow(false);
  }

  setLogoUrl() {
    try {
      this.user.getLogoUrl().then(
        data => {
          if (data['status'] == 1) {
            console.log('Setting logo to: ' + data['logo']);
            $("#van-logo").attr("href", data['logo']);
          } else {
            $("#van-logo").attr("href", wrapperGetLogoUrlInApp());
          }
        }
      );

    } catch (e) { }
  }

  setLogoUrlInApp()
  {
    try { $("#van-logo").attr("href", wrapperGetLogoUrlInApp()); }
    catch (e) { }
  }

  /**
  * Checks if FastSpring sent us data that needs to be 
  */
  fastSpringUrlProcessed() {
    var params = (location.search + '').toLowerCase();
    var hash = (location.hash + '');
    if (params.indexOf('fscnext=') > -1) {
      this.logger.write2log('fastSpringUrlProcessed', 'Found FastSpring url with: ' + params + ' and hash: ' + hash, 'P');
      var hashLower = hash.toLowerCase();
      var redirectTo = decodeURIComponent(hash);
      if (hashLower.indexOf('#!/gallery#!') >= 0) {
        redirectTo = redirectTo.substring(12);
        this.logger.write2log('fastSpringUrlProcessed', 'Redirecting to ' + redirectTo, 'P');
        this.router.navigate([redirectTo], {});
        location.hash="";
        return true;
      } else {
        this.logger.write2log('fastSpringUrlProcessed', 'DO NOT KNOW WHERE TO REDIRECT: ' + params + ' and hash: ' + hash, 'W');
      }
    }
    return false;
  }

  /**
  * Registers store callbacks. Callbacks are received from outside of angular.
  * @param {any} reg
  */
  registerCallbacks(reg) {
    try {
      wrapperRegisterWebhookCallback(reg === true ? (event) => { this.webhookCallback(event); } : undefined);
      wrapperRegisterCloseCallback(reg === true ? () => { this.closeCallback(undefined); } : undefined);
      if (reg)
        this.logger.write2log('registerCallbacks', 'Registered payment callbacks on upload page', 'P');
      else
        this.logger.write2log('registerCallbacks', 'UNRegistered payment callbacks on upload page', 'P');
    } catch (e) {
      this.logger.write2log('registerCallbacks', e.message, 'E');
    }
  }
  webhookCallback(event) {
    this.ngZone.run(() => { this.processWebhookEvent(event); });
  }
  processWebhookEvent(event) {
    this.logger.write2log('processWebhookEvent', 'Ignoring webhook event.', 'P');
  }

  closeCallback(event) {
    this.ngZone.run(() => { this.processCloseEvent(); });
  }

  processCloseEvent() {
    this.logger.write2log('processCloseEvent', 'Ignoring store close event.', 'P');
  }

  setOverflow(allow) {
    var b = document.body;
    if (b) {
      if (allow) {
        if (b.classList.contains('allow-scroll') == false)
          b.classList.add('allow-scroll');
      } else {
        if (b.classList.contains('allow-scroll'))
          b.classList.remove('allow-scroll');
      }
    }
  }

  ////////////////

  activate() {
    this.list();

    window.loginHandler = () => {
      this.ngZone.run(() => {
        this.windowLoginHandler();
      });
    };

    this.setOverflow(true);
  }

  list() {
    this.gallery.list(undefined).then(
      data => {
        if (data !== undefined) this.documents = data['documents'];
      }
    );
  }

  deleteFile(f) {
    //this.dialogs.openDeleteDialog(translations['document'], f, (id) { del(id); });
  }

  del(f) {
    this.gallery.deleteDocument(f).then(
      data=> {
        if (data !== undefined && data['status'] === 0) this.list();
        else this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotDeleteTheFile'));
      }
    );
  }

  /**
  * Fetches the pages of the document f from the server
  * and opens the first page.
  * @param {any} f
  */
  openDocument(f) {
    this.gallery.list(f).then(
      data=> {
        if (data !== undefined && data['status'] === 0) {
          var pages = data['pages'];
          //$location.path("/gallery/" + f + "/" + pages[0]);
          this.router.navigate(['/', 'gallery', '/', f, '/', pages[0]], {});
        } else {
          this.logger.write2log("OPEN DOCUMENT", "Failed to open document", "W");
          this.dialogs.openMessageDialog(this.translateService.instant('SelectDocument'), this.translateService.instant('CouldNotOpenFile'));
        }
      }
    )
  }

  documentDownloadLink(f) {
    return "/api/gallery/document/" + f;
  }

  openFileBrowser() {
    var uploadTag = document.getElementById("fileInput");
    if (uploadTag) uploadTag.click();
  }

  // ===================
  // Upload files
  // ===================
  @HostListener("dragover", ["$event"]) public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();

    let files: File[] = [];
    let firstFile: File;
    for (let i = 0; i < evt.dataTransfer.files.length; i++) {
      firstFile = evt.dataTransfer.files[0];

    }

    this.upload(firstFile);
  }

  dragEnter() {
    this.dragClass = 'dropHere-active';
  }

  dragLeave() {
    this.dragClass = 'dropHere-inactive';
  }

  fileDropped(files) {
    this.dragClass = 'dropHere-inactive';
    this.upload(files[0]);
  }

  uploadFileFromFileInput() {
    this.upload();
  }

  upload(paramF=undefined) {
    var f = document.getElementById("fileInput") as HTMLInputElement; 

    var file;
    if (paramF)
      file = paramF;
    else
      file = f.files[0];
    var fileName = file.name;
    var fileType = "";

    if (file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf")) {
      fileType = "pdf";
    } else if (file.type === "application/msword" || file.name.toLowerCase().endsWith(".doc")) {
      fileType = "doc";
    } else if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || file.name.toLowerCase().endsWith(".docx")) {
      fileType = "docx"
    } else if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.name.toLowerCase().endsWith(".xlsx")) {
      fileType = "xlsx"
    } else if (file.type === "application/vnd.ms-excel" || file.name.toLowerCase().endsWith(".xls")) {
      fileType = "xls";
    } else if (file.type === "application/vnd.ms-powerpoint" || file.name.toLowerCase().endsWith(".ppt")) {
      fileType = "ppt";
    } else if (file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation" || file.name.toLowerCase().endsWith(".pptx")) {
      fileType = "pptx";
    } else if (file.type === "image/jpeg" || file.name.toLowerCase().endsWith(".jpg") || file.name.toLowerCase().endsWith(".jpeg")) {
      fileType = "jpg";
    } else if (file.type === "image/gif" || file.name.toLowerCase().endsWith(".gif")) {
      fileType = "gif";
    } else if (file.type === "image/png" || file.name.toLowerCase().endsWith(".png")) {
      fileType = "png";
    } else if (file.type === "image/bmp" || file.name.toLowerCase().endsWith(".bmp")) {
      fileType = "bmp";
    } else if (file.type === "application/vnd.oasis.opendocument.text" || file.type === "application/odt" || file.name.toLowerCase().endsWith(".odt")) {
      fileType = "odt";
    } else if (file.type === "application/vnd.oasis.opendocument.spreadsheet" || file.type === "application/ods" || file.name.toLowerCase().endsWith(".ods")) {
      fileType = "ods";
    } else if (file.type === "application/vnd.oasis.opendocument.presentation" || file.type === "application/odp" || file.name.toLowerCase().endsWith(".odp")) {
      fileType = "odp";
    } else if (file.name.toLowerCase().endsWith(".hwp") || file.type === "application/hwp") {
      fileType = "hwp";
    } else if (file.name.toLowerCase().endsWith(".swrd") || file.type === "application/swrd") {
      fileType = "swrd";
    } else if (file.name.toLowerCase().endsWith(".pages") || file.type === "application/x-iwork-pages-sffpages") {
      fileType = "pages";
    } else if (file.name.toLowerCase().endsWith(".key") || file.type === "application/x-iwork-keynote-sffkey") {
      fileType = "key";
    } else if (file.name.toLowerCase().endsWith(".numbers") || file.type === "application/x-iwork-numbers-sffnumbers") {
      fileType = "numbers";
    } else if (file.name.toLowerCase().endsWith(".tif") || file.type === "image/tif" || file.type === "image/x-tif" || file.type === "application/tif" || file.type === "application/x-tif") {
      fileType = "tif";
    } else if (file.name.toLowerCase().endsWith(".tiff") || file.type === "image/tiff" || file.type === "image/x-tiff" || file.type === "application/tiff" || file.type === "application/x-tiff") {
      fileType = "tiff";
    } else if (file.name.toLowerCase().endsWith(".vsdx") || file.type === "application/vsdx") {
      fileType = "vsdx";
    } else if (file.name.toLowerCase().endsWith(".vsd") || file.type === "application/vsd" || file.type === "application/vnd.visio") {
      fileType = "vsd";
    } else if (file.name.toLowerCase().endsWith(".vdx") || file.type === "application/vdx") {
      fileType = "vdx";
    } else if (file.name.toLowerCase().endsWith(".heic") || file.type === "image/heic" || file.type === "image/heif") {
      fileType = "heic";
    } else {
      try {
        var fileParts = fileName.split(".");
        var fileExt = fileParts[fileParts.length - 1];
        if (fileExt.toLowerCase() === "swrd") {
          fileType = "swrd";
        }
      } catch (e) {
        // Ignore this error?
      }
    }


    if (fileType === "") {
      this.dialogs.openMessageDialog(this.translateService.instant('SelectDocument'), this.translateService.instant('UnsupportedFileFormat'));
      this.resetFileInput();
      return;
    }

    var data = new FormData();
    data.append('file', file);

    this.loading = true;
    this.setLogoUrlInApp();
    this.gallery.upload(data, fileName, fileType, -1).then(
      data => {
        if (data !== undefined && data['status'] === 0) {
          var pages = data['pages'];
          var dir = data['dir'];
          //$location.path("/gallery/" + dir + "/" + pages[0]);
          this.loading = false;
          this.router.navigate(['/', 'gallery', dir, pages[0]], {});
        } else {
          this.loading = false;
          this.setLogoUrl();
          this.logger.write2log("UPLOAD", "Failed to open document", "W");
          this.resetFileInput();
          switch (data['status']) {
            case -2:
              this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotOpenFileTooBig'));
              break;
            default:
              this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotOpenFile'));
              break;
          }
        }
      }
    );
  }

  resetFileInput() {
    var form = document.getElementById("fileInputForm") as HTMLFormElement;
    if (form) form.reset();
  }

  // ===================
  // GOOGLE DRIVE
  // ===================
  fetchFromGDrive() {
    if (wrappergDriveTokenClient) {
      if (wrappergDriveTokenClient.callback === null || wrappergDriveTokenClient.callback === undefined || wrappergDriveTokenClient.callback === '') {
        // Request an access token
        wrappergDriveTokenClient.callback = async (response) => {
          if (response.error !== undefined) {
            throw (response);
          }
          wrapperSetGDriveAccessToken(response.access_token);
          this.createGDrivePicker();
        };
      }

      if (wrapperGetgDriveAccessToken === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        wrappergDriveTokenClient.requestAccessToken({ prompt: 'consent' });
      } else {
        // Skip display of account chooser and consent dialog for an existing session.
        wrappergDriveTokenClient.requestAccessToken({ prompt: '' });
      }
    }
  }

  //async fetchFromGDrive() {
  //  try {
  //    var res = await window.gapi.auth.authorize(
  //      {
  //        'client_id': this.gDriveClientId,
  //        'scope': this.gDriveScope,
  //        'immediate': false
  //      });

  //    this.handleGDriveAuthResult(res);
  //  } catch (e) {
  //    this.logger.logInternalError("GDRIVE PICKER", e.message);
  //  }
  //}

  //handleGDriveAuthResult(authResult) {
  //  try {
  //    if (authResult && !authResult.error) {
  //      this.gDriveToken = authResult.access_token;
  //      this.createGDrivePicker();
  //    }
  //  } catch (e) {
  //    this.logger.logInternalError("GDRIVE PICKER", e.message);
  //  }
  //}

  createGDrivePicker() {
    try {
      let pickerBuilder = new google.picker.PickerBuilder();
      let picker = pickerBuilder.
        addView(new google.picker.DocsView().
          setParent('root').
          setIncludeFolders(true)
        ).
        setOAuthToken(wrapperGetgDriveAccessToken()).
        setDeveloperKey(this.gDriveDeveloperKey).
        setCallback(data => { this.gDrivePickerCallback(data) }).
        setAppId(20355500945).
        build();
      picker.setVisible(true);
    } catch (e) {
      this.logger.logInternalError("GRDIVE PICKER", e.message);
    }
  }

  gDrivePickerCallback(data) {
    if (data.action === 'picked') {
      this.loading = true;
      this.setLogoUrlInApp();
      this.gallery.fetchGDriveFile(data.docs[0], wrapperGetgDriveAccessToken()).then(
        data => {
          if (data !== undefined && data['status'] === 0) {
            var pages = data['pages'];
            var dir = data['dir'];
            //$location.path("/gallery/" + dir + "/" + pages[0]);
            this.loading = false;
            this.router.navigate(['/', 'gallery', dir, pages[0]], {});
          } else {
            this.loading = false;
            this.setLogoUrl();
            this.logger.write2log("GDRIVE PICKER", "Failed to open document", "W");
            switch (data['status']) {
              case -2:
                this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotOpenFileTooBig'));
                break;
              default:
                this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotOpenFile'));
                break;
            }
          }
        }
      );
    }
  }


  // ==================
  // DROPBOX
  // ==================

  fetchFromDropbox() {
    try {
      Dropbox.choose(this.dbOptions);
    } catch (e) {
      this.logger.logInternalError("DROPBOX PICKER", e.message);
    }
  }

  dropboxCallback(files) {
    this.loading = true;
    this.setLogoUrlInApp();
    console.log(files[0]);
    this.gallery.fetchDropboxFile(files[0]).then(
      data=> {
        if (data !== undefined && data['status'] === 0) {
          var document = data['dir'];
          var pages = data['pages'];
          //$location.path("/gallery/" + document + "/" + pages[0]);
          this.router.navigate(['/', 'gallery', document, pages[0]], {});
        } else {
          this.loading = false;
          this.setLogoUrl();
          this.logger.write2log("DROPBOX PICKER", "Failed to open document", "W");
          switch (data['status']) {
            case -2:
              this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotOpenFileTooBig'));
              break;
            default:
              this.dialogs.openMessageDialog(this.translateService.instant('Error'), this.translateService.instant('CouldNotOpenFile'));
              break;
          }
        }
      },
      response => {
        this.loading = false;
        this.list();
      }
    );
  }

  // ==================
  // LOGIN
  // ==================

  windowLoginHandler() {
    this.doLogin(true);
  }

  doLogin(applyScope: any = undefined) {

    if (applyScope) {
      //$scope.$apply();
      this.ngZone.run(() => { });
    }

    this.goToLoginPage();
  }  

  goToLoginPage() {
    var l = wrapperGetNativeLogin();
    if (wrapperGetNativeLogin()) {

      var currentPath = this.location.path();// undefined /*= location.path();*/
      var currentSearch = window.location.search;// undefined /*= location.search();*/
      var state = "s" + Math.floor(Math.random() * 1000000);

      this.user.saveCurrentPath(currentPath, currentSearch, state);
      this.user.setOpenPopupAfterLogin(null);

      wrapperRequestNativeLogin(userId => {
        this.logger.write2log("requestNativeLogin", "received native login for " + userId, "P");
        this.ngZone.run(() => {
          this.user.saveUserId(userId);
        });
      });
    } else {
      this.user.getLoginPage(wrapperGetSiteLanguage(), wrapperGetSiteVersion(), wrapperGetSiteLogo()).then(
        data => {
          if (data['status'] === 0) {

            var loginUrl = data['loginUrl'];

            var currentPath = window.location.href; //this.router.url;
            var currentSearch = window.location.search; //undefined; /*this.location.search();*/
            var state = "s" + Math.floor(Math.random() * 1000000);

            this.user.saveCurrentPath(currentPath, currentSearch, state);

            var stateString = wrapperGetSiteLanguage() + ":" + wrapperGetSiteVersion() + ":" + wrapperGetSiteLogo() + ":" + state;
            var clientMode = wrapperGetCalledFromClientApi() === "False" ? false : true;

            let navigateUrl = loginUrl + "&state=" + stateString + "&apple_login=" + (clientMode ? "yes" : "no");
            window.location.assign(navigateUrl);
          }
        }
      );
    }
  }
}
